// Generated by purs version 0.13.8
"use strict";
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Decode_Generic_Rep = require("../Data.Argonaut.Decode.Generic.Rep/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Argonaut_Encode_Generic_Rep = require("../Data.Argonaut.Encode.Generic.Rep/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Generic_Rep = require("../Data.Generic.Rep/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Lunarbox_Data_ProjectId = require("../Lunarbox.Data.ProjectId/index.js");
var Lunarbox_Data_Tab = require("../Lunarbox.Data.Tab/index.js");
var UserProject = function (x) {
    return x;
};
var TutorialId = function (x) {
    return x;
};
var Tab = (function () {
    function Tab(value0) {
        this.value0 = value0;
    };
    Tab.create = function (value0) {
        return new Tab(value0);
    };
    return Tab;
})();
var showUserProject = new Data_Show.Show(function (v) {
    return v.value0;
});
var showTutorialId = Data_Show.showInt;
var semigroupUserProject = new Data_Semigroup.Semigroup(function (a) {
    return function (b) {
        return b;
    };
});
var genericEditorElement = new Data_Generic_Rep.Generic(function (x) {
    return x.value0;
}, function (x) {
    return new Tab(x);
});
var eqUserProject = new Data_Eq.Eq(function (x) {
    return function (y) {
        return Data_Eq.eq(Data_Tuple.eqTuple(Data_Eq.eqString)(Lunarbox_Data_ProjectId.eqProjectId))(x)(y);
    };
});
var eqTutorialId = new Data_Eq.Eq(function (x) {
    return function (y) {
        return x === y;
    };
});
var ordTutorialId = new Data_Ord.Ord(function () {
    return eqTutorialId;
}, function (x) {
    return function (y) {
        return Data_Ord.compare(Data_Ord.ordInt)(x)(y);
    };
});
var encodeJsonTutorialId = Data_Argonaut_Encode_Class.encodeJsonInt;
var encodeJsonEditorElement = new Data_Argonaut_Encode_Class.EncodeJson(Data_Argonaut_Encode_Generic_Rep.genericEncodeJson(genericEditorElement)(Data_Argonaut_Encode_Generic_Rep.encodeRepConstructor(new Data_Symbol.IsSymbol(function () {
    return "Tab";
}))(Data_Argonaut_Encode_Generic_Rep.encodeRepArgsArgument(Lunarbox_Data_Tab.encodeJsonTab))));
var decodeJsonTutorialId = Data_Argonaut_Decode_Class.decodeJsonInt;
var decodeJsonEditorElement = new Data_Argonaut_Decode_Class.DecodeJson(Data_Argonaut_Decode_Generic_Rep.genericDecodeJson(genericEditorElement)(Data_Argonaut_Decode_Generic_Rep.decodeRepConstructorArg(new Data_Symbol.IsSymbol(function () {
    return "Tab";
}))(Lunarbox_Data_Tab.decodeJsonTab)));
module.exports = {
    Tab: Tab,
    TutorialId: TutorialId,
    UserProject: UserProject,
    genericEditorElement: genericEditorElement,
    encodeJsonEditorElement: encodeJsonEditorElement,
    decodeJsonEditorElement: decodeJsonEditorElement,
    eqTutorialId: eqTutorialId,
    ordTutorialId: ordTutorialId,
    showTutorialId: showTutorialId,
    encodeJsonTutorialId: encodeJsonTutorialId,
    decodeJsonTutorialId: decodeJsonTutorialId,
    eqUserProject: eqUserProject,
    showUserProject: showUserProject,
    semigroupUserProject: semigroupUserProject
};
